import React, { Component } from 'react';
import '../App.css';
import Typing from 'react-typing-animation';



const Header=(props)=> {

    return (
        <header>
            <div className="developer">
                <Typing speed={125}>
                    <h1  className={props.isMobile? "name-mobile":"name"}>Yousef Ahmed </h1>

                    <h1>Software Developer </h1>
                    <h1 className= "commentedOut">// Bioengineer</h1>
                    <Typing.Reset delay={10000000}/>
                </Typing >
            </div>
        </header>
    );
}


export default Header;